import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FoodPlannerView } from "../VIEW/FoodPlannerView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function FoodPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.FOOD}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <FoodPlannerView />;
}

export default FoodPage;
